<template>
  <div class="export-pdf-container cert-container">
    <div class="box-header">
      <p class="title">OVERALL RATING</p>
    </div>
    <div class="content">
      <div class="box-certificate">
        <img class="certificate-logo" :src="'img/imgPdf/logo-upm.png'" alt="" />
        <p class="cert-uni-name">{{ uniData.name }}</p>
        <!--        <p class="cert-uni-nation">{{ universityInfo.nation }}</p>-->
        <p class="cert-uni-nation">{{ uniData.nation }}</p>
        <img
          :src="
            `img/icon-certificate/${getStarImg(
              uniData.university_type_id === 1 ? 'research' : 'applied',
              uniSummaryRatingData.star,
              uniSummaryRatingData.extra
            )}`
          "
          alt=""
          class="research-plus"
        />
        <!--        <p class="cert-year">{{ new Date().getFullYear() }}</p>-->
        <p class="cert-uni-type">
          {{ uniData.university_type ? uniData.university_type.name : "" }}
        </p>
      </div>
      <div class="box-chieved">
        <div
          class="box-score"
          :class="[{ 'box-score-applied': uniData.university_type_id !== 1 }]"
          style=""
        ></div>
        <div class="box-chieved-score">
          <p>
            Achieved score<br />
            {{ uniSummaryRatingData.score | formatNumber }}
          </p>
        </div>
        <div class="box-max-score">
          <p>
            Weight<br />
            {{ uniSummaryRatingData.weight | formatNumber }}
          </p>
        </div>
      </div>
    </div>
    <img class="overall-bottom" :src="'img/imgPdf/bg-certificate.png'" alt="" />
  </div>
</template>

<script>
export default {
  name: "Overall",
  data() {
    return {
      uniData: {
        name: "",
        nation: "",
        university_type_id: "",
        university_type: {
          name: ""
        }
      },
      uniSummaryRatingData: {
        score: 0,
        weight: 0,
        star: 0,
        extra: null
      }
    };
  },
  props: {
    universityInfo: {},
    uniSummaryRating: {}
  },
  watch: {
    universityInfo: {
      handler(newVal) {
        if (!newVal) return;
        this.uniData.name = newVal.name;
        this.uniData.nation = newVal.nation;
        this.uniData.university_type_id = newVal.university_type_id;
        this.uniData.university_type = newVal.university_type;
      },
      deep: true,
      immediate: true
    },
    uniSummaryRating: {
      handler(newVal) {
        this.uniSummaryRatingData.extra = newVal.extra;
        this.uniSummaryRatingData.star = newVal.star;
        this.uniSummaryRatingData.score = newVal.score;
        this.uniSummaryRatingData.weight = newVal.weight;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    universityTypeName() {
      if (!this.uniData) return "";
      switch (this.uniData.university_type.name) {
        case "Research university":
          return "Research oriented university";
        case "Applied university":
          return "Applied oriented university";
        default:
          return this.uniData.university_type.name;
      }
    }
  },
  created() {
    this.uniData.name = this.universityInfo.name;
    this.uniData.nation = this.universityInfo.nation;
    this.uniData.university_type_id = this.universityInfo.university_type_id;
    this.uniData.university_type = this.universityInfo.university_type;
    this.uniSummaryRatingData.extra = this.uniSummaryRating.extra;
    this.uniSummaryRatingData.star = this.uniSummaryRating.star;
    this.uniSummaryRatingData.score = this.uniSummaryRating.score;
    this.uniSummaryRatingData.weight = this.uniSummaryRating.weight;
  },
  methods: {
    getStarImg(divisionName, star = "", extra = "") {
      const displayStar =
        star && star >= 1 ? Math.floor(star / 1).toFixed(0) : 1;
      return `${divisionName}_${_.toLower(extra)}${displayStar}.png`;
    },
    getCategoryStarImg(divisionName, star = "") {
      const displayStar = star && star >= 1 ? parseInt(star) : 1;
      return `${divisionName}_${displayStar}.svg`;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/pdf.scss";
</style>
